<script>
import {defineComponent, ref} from "vue";
import {usePopupsControlStore} from "@js/store/PopupsControlStore.js";

export default defineComponent({
    name: "FormAlreadySentPopup",
    setup() {
        const popupsControlStore = usePopupsControlStore()
        const modalFormAlreadySentPopupRef = ref(null)

        const closeModal = () => {
            popupsControlStore.isFormAlreadySentPopupVisible = false
        }

        const handleBackgroundClick = (event) => {
            if (!modalFormAlreadySentPopupRef.value.contains(event.target)) {
                closeModal()
            }
        }

        return {
            popupsControlStore,
            closeModal,
            modalFormAlreadySentPopupRef,
            handleBackgroundClick
        }
    },
});
</script>

<template>
    <div v-if="popupsControlStore.isFormAlreadySentPopupVisible"
         class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 transition-opacity"
         @click="handleBackgroundClick">
        <div ref="modalFormAlreadySentPopupRef"
             class="relative bg-gray-800 text-white rounded-2xl shadow-lg w-[90%] md:w-auto p-6 md:p-10 intro-y">
            <button @click="closeModal"
                    class="absolute top-2 right-2 text-gray-400 hover:text-white focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
            </button>
            <div class="text-center">
                <div class="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-blue-500 rounded-full">
                    <svg class="w-6 h-6 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                         height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M12 8v4l3 3M3.22302 14C4.13247 18.008 7.71683 21 12 21c4.9706 0 9-4.0294 9-9 0-4.97056-4.0294-9-9-9-3.72916 0-6.92858 2.26806-8.29409 5.5M7 9H3V5"/>
                    </svg>
                </div>
                <h2 class="text-2xl font-bold">
                    Заявка уже была отправлена!
                </h2>
                <p class="mt-2 text-md text-gray-300">
                    Скоро наш оператор с Вами свяжется.
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>
